import signIn from './signIn';
import landing from './landing';
import privacyPolicy from './privacyPolicy';
import terms from './terms';
import commercial from './commercial';
import questions from './questions';
import contact from './contact';
import signUp from './signUp';
import resetPassword from './resetPassword';
import dashboard from './dashboard';
import myPage from './myPage';
import disasterNotices from './disasterNotices';
import disasterSettings from './disasterSettings';
import admin from './admin';
import options from './options';
import users from './users';
import send from './send';
import price from './price';
import csv from './csv';
import safety from './safety';
import reason from './reason';

export default {
  signIn,
  landing,
  privacyPolicy,
  terms,
  commercial,
  questions,
  contact,
  signUp,
  resetPassword,
  dashboard,
  myPage,
  disasterNotices,
  disasterSettings,
  admin,
  options,
  users,
  send,
  price,
  csv,
  safety,
  reason,
};
